export default __webpack_public_path__ + "static/media/promo-3.7d36dfa1.png";